import { SplatEffectsLayer } from '../../../SplatEffectsLayer';
import { BodyTypes } from '../../../LevelManager';
import { ObstacleSpine } from './ObstacleSpine';

export class ObstacleSnowdrift extends ObstacleSpine {
  public static animations = {
    Idle: 'snowdrift-idle',
    Appear: 'snowdrift-grow',
    HitEffect: 'snowdrift-impact'
  } as const;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'snowdrift', ObstacleSnowdrift.animations.Idle);

    this.injectMatter(this as unknown as Phaser.GameObjects.GameObject);
    this.addToUpdateList();

    this.setDepth(y);
  }

  public init(): void {}

  public onFire() {
    this.setAnimation(0, ObstacleSnowdrift.animations.Appear, false);
    this.addAnimation(0, ObstacleSnowdrift.animations.Idle, true);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    let matterShape = this.scene.matter.bodies.rectangle(0, (this.height * 0.2) / 2, this.width * 0.8, this.height * 0.2, {
      label: BodyTypes.Obstacle,
      isStatic: true,
      isSensor: true
    });

    matterShape.position.y = this.displayOriginY * this.scaleY * 0.5;

    let matterSprite = this.scene.matter.add.gameObject(target, matterShape) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  public override onHit(wasPlayer: boolean, hitPointX: number, delay: number): void {
    this.scene.events.emit(SplatEffectsLayer.events.SplatSnow, hitPointX - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY, 5);
    this.setAnimation(0, ObstacleSnowdrift.animations.HitEffect, false);
    this.hasBeenHit = true;

    // this.scene.add.tween({
    //   targets: this,
    //   alpha: 0,
    //   duration: 250,
    //   ease: Phaser.Math.Easing.Circular.InOut,
    //   delay: delay,
    //   onComplete: () => {
    //     this.hasBeenHit = true;
    //   },
    //   onCompleteScope: this
    // });
  }
}
